import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export function AdminHeader(): React.JSX.Element {
    const location = useLocation();

    const isActive = (path: string): boolean => {
        return location.pathname === path;
    };

    const navItems = [
        { path: '/admin', label: 'Dashboard' },
        { path: '/admin/users', label: 'User Management' },
        { path: '/admin/prompts', label: 'Prompt Editor' },
    ];

    return (
        <header className="bg-white shadow-sm border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex">
                        <div className="flex-shrink-0 flex items-center">
                            <span className="text-xl font-bold text-gray-900">List8 Admin</span>
                        </div>
                        <nav className="hidden sm:ml-6 sm:flex sm:space-x-8">
                            {navItems.map((item) => (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200 ${isActive(item.path)
                                            ? 'border-blue-500 text-gray-900'
                                            : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                                        }`}
                                >
                                    {item.label}
                                </Link>
                            ))}
                        </nav>
                    </div>
                    <div className="flex items-center">
                        <Link
                            to="/dashboard"
                            className="text-sm font-medium text-blue-600 hover:text-blue-500"
                        >
                            Return to App
                        </Link>
                    </div>
                </div>
            </div>
            {/* Mobile menu placeholder - can be expanded if needed */}
            <div className="sm:hidden border-t border-gray-200 bg-gray-50">
                <div className="flex justify-around p-2">
                    {navItems.map((item) => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`px-3 py-2 rounded-md text-xs font-medium ${isActive(item.path)
                                    ? 'bg-blue-100 text-blue-700'
                                    : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            {item.label}
                        </Link>
                    ))}
                </div>
            </div>
        </header>
    );
}
